// extracted by mini-css-extract-plugin
export default {"posts":"PostDetail_posts__KqiVT"};